import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiXCircle } from "react-icons/fi";

/** One icon ↔ one share/copy link */
export const SHARE_CHANNELS = [
  {
    key: "facebook",
    label: "Facebook",
    Icon: FaFacebookF,
    className: "bg-[#1877F2]",
    iconClassName: "w-4 h-4",
  },
  {
    key: "instagram",
    label: "Instagram",
    Icon: FaInstagram,
    className:
      "bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]",
    iconClassName: "w-5 h-5",
  },
  {
    key: "twitter",
    label: "X / Twitter",
    Icon: FaXTwitter,
    className: "bg-black",
    iconClassName: "w-4 h-4",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    Icon: FaLinkedinIn,
    className: "bg-[#0A66C2]",
    iconClassName: "w-4 h-4",
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    Icon: FaWhatsapp,
    className: "bg-[#25D366]",
    iconClassName: "w-5 h-5",
  },
];

/**
 * Shared "Share this via" body — aligned header, URL row, and social icons.
 */
export default function ShareViaPanel({
  displayUrl,
  onClose,
  onCopyUrl,
  onShareChannel,
  copyMessage,
}) {
  return (
    <div className="w-full">
      <div className="relative flex items-center justify-center px-5 py-1 mb-2">
        <h3 className="text-black text-center font-normal leading-none">
          Share this via
        </h3>
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
          aria-label="Close share"
        >
          <FiXCircle className="text-black w-5 h-5" />
        </button>
      </div>

      <div className="py-4 px-5 border-t border-b border-[#D6D6D6]">
        <div className="flex items-center gap-2 mb-4">
          <input
            type="text"
            readOnly
            value={displayUrl}
            onFocus={(e) => e.currentTarget.select()}
            className="min-w-0 flex-1 rounded-xl px-3 py-1.5 h-9 text-xs text-[#3C3C3C] bg-[#E8E8E8]"
          />
          <button
            type="button"
            onClick={onCopyUrl}
            className="shrink-0 bg-[#FBBC05] text-black px-3 py-1.5 rounded-xl btn-text font-medium flex items-center justify-center h-9 whitespace-nowrap cursor-pointer"
          >
            Copy
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {SHARE_CHANNELS.map((ch) => (
            <button
              key={ch.key}
              type="button"
              onClick={() => onShareChannel(ch.key)}
              className={`h-11 w-11 rounded-full text-white flex items-center justify-center hover:opacity-90 cursor-pointer ${ch.className}`}
              aria-label={`Share on ${ch.label}`}
              title={`${ch.label} — copy this link`}
            >
              <ch.Icon className={ch.iconClassName} aria-hidden="true" />
            </button>
          ))}
        </div>

        {copyMessage ? (
          <div className="text-green-600 text-sm mt-3 text-center">
            {copyMessage}
          </div>
        ) : null}
      </div>
    </div>
  );
}
